'use strict'
import {Forms} from './Forms'

class FormsDefault extends Forms {
    static callback(xmlHttp) {
        xmlHttp.form.querySelector('.popup-content').style.display = 'none'
        xmlHttp.form.querySelector('.popup-complete').style.display = 'contents'
    }
}
window.TimeCity = window.TimeCity || {};
window.TimeCity.FormsDefault = FormsDefault;